export const localStorageKeyRedirectFrom = "redirect_from";
